module.exports = __webpack_public_path__ + "img/aoxintong_2025_04_25.1a3f1488.png";